import { useState } from "react";
import Header from "@/components/Header";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Play, Lightbulb, Video, Palette } from "lucide-react";
const ExplainerVideo = () => {
  const {
    language,
    setLanguage,
    content: currentContent
  } = useLanguage();
  return <div className="min-h-screen bg-background">
      <Header language={language} onLanguageChange={setLanguage} content={currentContent.header} />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="py-20 px-4">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="hero-text">Förklaringsvideofilmer</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8">Animerade videor som förklarar komplexa koncept på ett enkelt och engagerande sätt. Perfekt för att förklarar affärsidéer, utbildning och marknadsföring.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="bg-gradient-primary border-0 hover:opacity-90">
                <a href="https://volym.typeform.com/to/vvm1IndH?utm_source=xxxxx&utm_campaign=xxxxx&utm_content=xxxxx" target="_self">
                  Få prisförslag
                </a>
              </Button>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-20 px-4 bg-secondary/30">
          <div className="container mx-auto max-w-6xl">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Lightbulb className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">Komplex blir enkelt</h3>
                <p className="text-muted-foreground">
                  Förenkla svåra koncept med visuella metaforer och tydlig storytelling.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Video className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">2D & 3D Animation</h3>
                <p className="text-muted-foreground">
                  Professionella animationer i både 2D och 3D beroende på dina behov.
                </p>
              </div>
              <div className="text-center p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <Palette className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-3">Varumärkesanpassning</h3>
                <p className="text-muted-foreground">
                  Anpassad design som speglar ditt varumärkes identitet och färgschema.
                </p>
              </div>
            </div>
          </div>
        </section>


        <ContactSection content={currentContent.contact} />
      </main>
      
      <Footer content={{
      company: "Volym Digitalbyrå AB",
      rights: language === "sv" ? "Alla rättigheter förbehållna." : "All rights reserved."
    }} />
    </div>;
};
export default ExplainerVideo;